<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22"
              >
                <i class="bx bxl-telegram bx-xl"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("telegram.search-group") }}</h5>
            </div>
          </div>
          <div class="row mt-5 mb-3">
            <div class="col-sm-12 text-right">
              <div class="input-group">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  placeholder="group name or username group.."
                  v-model="searchKey"
                  aria-describedby="search"
                  @keyup.enter="searchGroup"
                  v-on:input="removeSpace(searchKey)"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="searchGroup"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loadingsearch" class="row mt-5 mb-5 pb-4 mx-auto">
            <div class="text-center">
              <b-spinner label="Loading..."></b-spinner>
              <br />
              loading..
            </div>
          </div>
          <div
            v-if="error !== '' && !loadingsearch"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>
          <div
            v-if="error == '' && !loadingsearch && search && !SearchResult[0]"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ $t("all.dnf") }}</span>
            </div>
          </div>

          <div></div>
          <div class="row mt-1 px-2" v-if="SearchResult[0] && !loadingsearch">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <td width="35%">
                    <b>{{ $t("telegram.group-username") }}</b>
                  </td>
                  <td width="35%">
                    <b>{{ $t("telegram.tittle-group") }}</b>
                  </td>
                  <td class="text-right">
                    <b>{{ $t("telegram.action-group") }}</b>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(group, index) in SearchResult" :key="index">
                  <td width="35%">{{ group.username }}</td>
                  <td width="35%">{{ group.title }}</td>
                  <td class="text-right" width="30%">
                    <a
                      :href="'https://t.me/' + group.username"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><b-button
                        class="rounded btn-sm btn text-secondary mr-1 mb-1"
                        variant="secondary"
                        >{{ $t("telegram.view-group") }}</b-button
                      ></a
                    >
                    <b-button
                      class="btn-sm mb-1 rounded"
                      variant="success"
                      @click="joinGroup(group.username)"
                      >{{ $t("telegram.join-group") }}</b-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22"
              >
                <i class="bx bx-user bx-xl"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("telegram.search-members") }}</h5>
            </div>
          </div>
          <div class="row mt-4 mb-3">
            <div class="col-sm-12">
              <span class="text-muted mb-2">
                <b>*{{ $t("telegram.example") }} :</b> 6285790422395 /
                KangKuman</span
              >
              <div class="input-group mt-2">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  placeholder="phone number or username.."
                  v-model="searchKeyUsers"
                  aria-describedby="search"
                  @keyup.enter="SearchUsersTele"
                  v-on:input="removeSpaceUser(searchKeyUsers)"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="SearchUsersTele"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loading_search_users" class="row mt-5 mb-5 pb-4 mx-auto">
            <div class="text-center">
              <b-spinner label="Loading..."></b-spinner>
              <br />
              loading..
            </div>
          </div>
          <div
            v-if="error_users !== '' && !loading_search_users"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error_users }}</span>
            </div>
          </div>
          <div
            v-if="
              error_users == '' &&
              !loading_search_users &&
              search_users &&
              !SearchResultUsers[0]
            "
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ $t("all.dnf") }}</span>
            </div>
          </div>

          <div class="row mt-1 px-2" v-if="!loading_search_users">
            <div class="col-6" v-if="userList[0]">
              <h5>User Profile</h5>
              <hr />
              <div v-for="(list, index) in userList" :key="index">
                <p v-if="list.username">
                  <label for="validationCustom01">{{
                    $t("overview.table.all.username")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="list.username"
                    readonly
                  />
                </p>
                <p v-if="list.first_name">
                  <label for="validationCustom01">{{
                    $t("overview.table.all.first_name")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="list.first_name"
                    readonly
                  />
                </p>
                <p v-if="list.last_name">
                  <label for="validationCustom01">{{
                    $t("overview.table.all.last_name")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="list.last_name"
                    readonly
                  />
                </p>
                <p v-if="list.phone">
                  <label for="validationCustom01">{{
                    $t("overview.table.all.phone")
                  }}</label>
                  <input
                    type="text"
                    class="form-control bg-light mb-1"
                    :value="list.phone"
                    readonly
                  />
                </p>
              </div>
            </div>
            <div class="col-6" v-if="SearchResultUsers[0]">
              <h5>Group List</h5>
              <hr />
              <div>
                <span v-for="(list, index) in SearchResultUsers" :key="index">
                  <router-link
                    :to="'/group-telegram/view/' + list._id"
                    class="xbadge btn btn-light mr-1 mb-1 btn-sm text-secondary"
                    >{{ list._id }}
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row py-2 mb-3">
              <div class="col-sm-6">
                <h5 class="mt-2">
                  {{ $t("telegram.list-group.text") }} Telegram
                </h5>
              </div>
              <div class="col-sm-6 text-right" v-if="tableData[0] && !loading">
                <span class="text-secondary rounded btn btn-sm btn-light mr-1">
                  {{ $t("telegram.updated") }}
                  {{ formatDateRefresh(created_at_grouplist) }}</span
                >
                <b-button
                  class="btn btn-sm rounded"
                  variant="success"
                  @click="groupListTelegram"
                  ><span v-if="loadingupdate"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                    Loading..</span
                  ><span v-if="!loadingupdate"
                    ><i class="bx bx-history"></i>
                    {{ $t("telegram.update") }}</span
                  ></b-button
                >
              </div>
            </div>
            <div class="row mt-2" v-if="tableData[0] && !loading">
              <div class="col-sm-12 col-md-6">
                <!-- {{tableData}} -->
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-0"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("all.entries") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-if="tableData[0] && !loading">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(no)="row">
                  <div class="mt-2">
                    {{ row.item.no }}
                  </div>
                </template>
                <template #cell(username)="row">
                  <div class="col-sm-12">
                    <div class="media mt-2">
                      <img
                        :src="
                          avatar +
                          row.item.username +
                          '&path=media/telegram/' +
                          row.item.username
                        "
                        class="mr-3 mt-1 rounded-circle avatar-xs"
                        alt=" pic"
                      />

                      <div class="media-body">
                        <b
                          ><a
                            :href="'https://t.me/' + row.item.username"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="text-primary"
                          >
                            {{ row.item.title }}</a
                          ></b
                        >
                        <br />
                        <p class="text-secondary">@{{ row.item.username }}</p>
                      </div>
                    </div>
                  </div>
                </template>
                <template #cell(pin)="row">
                  <span v-if="row.item.pin" @click="unpin(row.item)">
                    <i class="bx bxs-pin bx-sm text-primary"></i>
                  </span>
                  <span v-else @click="pin(row.item)">
                    <i class="bx bx-pin bx-sm text-secondary"></i>
                  </span>
                </template>
                <template #cell(about)="row">
                  <span v-if="row.item.about">
                    {{ row.item.about.substring(1, 100) }} ..</span
                  >
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      name: 'group-view',
                      params: { id: row.item.username },
                    }"
                    ><b-button
                      class="btn-sm btn text-secondary mr-1 mb-1"
                      variant="secondary"
                    >
                      <!-- {{$t('all.view-detail')}} -->
                      <i class="bx bx-show-alt"></i> </b-button
                  ></router-link>
                  <b-button
                    class="btn-sm mb-1"
                    variant="danger"
                    @click="deleteGroup(row.item.username)"
                    v-if="user !== row.item.username"
                  >
                    <i class="bx bx-redo"></i>
                  </b-button>
                  <b-button
                    class="btn-sm mb-1"
                    variant="danger"
                    v-if="loadingleave && user == row.item.username"
                  >
                    <b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="col-sm-12 p-5 mb-5" v-if="loading && !tableData[0]">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
                <br />
                loading..
              </div>
            </div>
            <div class="col-sm-12 p-5 mb-5" v-if="!loading && !tableData[0]">
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div class="row" v-if="!loading && rows > 10">
              <div class="col-2 col-xl-1">
                <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                <label class="d-inline-flex align-items-center">
                  Page
                  <b-form-input
                    v-model="currentPage"
                    placeholder="Page"
                    class="form-control w-10 form-control ml-2"
                  ></b-form-input>
                </label>
              </div>
              <div class="col-10 col-xl-11 text-right">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import GroupService from "@/helpers/group.service.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PreferenceService from "@/helpers/preference.service.js";
import appConfig from "@/app.config";
import moment from "moment";
import Swal from "sweetalert2";

// import i18n from "../i18n";
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      avatar: process.env.VUE_APP_BASE_API_URL_OSINT + "stream-img/?name=",

      theme: localStorage.getItem("theme"),
      loading: false,
      user: "",
      pin_group: [],
      userList: [],
      loadingleave: false,
      created_at_grouplist: "",
      loadingupdate: false,
      loadingsearch: false,
      listGroup: [],
      totalResult: "",
      SearchResult: [],
      searchKeyUsers: "",
      totalResultUsers: "",
      SearchResultUsers: [],
      searchKey: "",
      elastic: "",
      search: false,
      error: "",
      loading_search_users: false,
      search_users: false,
      error_users: "",
      tableData: [],
      title: this.$t("telegram.group-messanger-monitor.text"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("telegram.group-messanger-monitor.text"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "3%" },
          label: "No",
        },
        { key: "title", thClass: "d-none", tdClass: "d-none" },
        {
          key: "username",
          sortable: true,
          thStyle: { width: "17%" },
          label: this.$t("telegram.table.username"),
        },
        {
          key: "about",
          sortable: true,
          label: this.$t("telegram.table.about"),
        },
        {
          key: "participants_count",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("telegram.table.member"),
        },
        {
          key: "date",
          sortable: true,
          thStyle: { width: "13%" },
          label: this.$t("telegram.table.join_at"),
        },
        {
          key: "pin",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
          label: "Pin",
        },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "15%" },
          label: this.$t("telegram.table.action"),
        },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    searchGroup() {
      (this.error = ""), (this.loadingsearch = true), (this.search = true);
      this.SearchResult = [];
      const data = {
        group: this.searchKey,
      };
      // console.log(data);
      GroupService.searchGroupTelegram(data)
        .then((response) => {
          this.SearchResult = response.data.output;
          // console.log(response.data);
          this.loadingsearch = false;
        })
        .catch((err) => {
          console.log("eror cuy", err);
          // if( err.response.status == 500 ){
          //   this.error = this.$t('all.error-500');
          //   this.loadingsearch == false;
          // } else if( err.response.status == 404 ){
          //   this.error = this.$t('all.error-404');
          //   this.loadingsearch == false;
          // }
          this.loadingsearch = false;
        });
    },
    getPreferences() {
      this.loading = true;
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.groupList();
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    groupList() {
      var name = "telegram";
      GroupService.getTelegramGroupElastic(this.elastic, name)
        .then((response) => {
          // console.log("response => ", response.data);
          this.tableData = [];
          this.pin_group = [];
          this.created_at_grouplist = response.data._source.created_at;
          response.data._source.listgroup.forEach((val) => {
            const data = {
              id: val.id,
              title: val.title,
              username: val.username,
              participants_count: val.participants_count,
              date: this.formatDate(val.date),
              about: val.about,
              message: val.message,
              pin: val.pin,
            };
            this.tableData.push(data);
            if (val.pin) {
              this.pin_group.push(data);
            }
            this.totalResult = response.data._source.listgroup.length;
            this.loading = false;
          });
          this.sortingArray();
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.groupListTelegram();
          } else {
            console.log(err);
            this.loading = false;
          }
        });
    },
    groupListTelegram() {
      (this.error = ""), (this.search = false);
      this.SearchResult = [];
      this.loadingsearch = false;
      this.searchKey = "";
      this.tableData = [];
      this.loading = true;
      this.loadingupdate = true;

      // console.log('this pin', this.pin_group);

      GroupService.getTelegramGroup()
        .then((response) => {
          // this.listGroup = response.data.output;
          const pin_1 = this.pin_group[0] ?? "-";
          const pin_2 = this.pin_group[1] ?? "-";
          const pin_3 = this.pin_group[2] ?? "-";
          const pin_4 = this.pin_group[3] ?? "-";
          const pin_5 = this.pin_group[4] ?? "-";
          response.data.output.forEach((val) => {
            if (
              val.id == pin_1.id ||
              val.id == pin_2.id ||
              val.id == pin_3.id ||
              val.id == pin_4.id ||
              val.id == pin_5.id
            ) {
              var data_res_status = {
                id: val.id,
                title: val.title,
                username: val.username,
                participants_count: val.participants_count,
                date: this.formatDate(val.date),
                about: val.about,
                message: val.message,
                pin: 1,
              };
            } else {
              var data_res_status = {
                id: val.id,
                title: val.title,
                username: val.username,
                participants_count: val.participants_count,
                date: this.formatDate(val.date),
                about: val.about,
                message: val.message,
                pin: 0,
              };
            }
            // console.log('this data', data_res_status);

            this.listGroup.push(data_res_status);
            this.tableData.push(data_res_status);
          });

          this.totalResult = response.data.output.length;
          this.loading = false;
          this.loadingupdate = false;
          this.createGroupList();
        })
        .catch((err) => {
          console.log("grouplist err ->", err);
          this.loadingupdate = false;
          this.loading = false;
        });
    },
    createGroupList() {
      var platform = "telegram";
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: platform,
        listgroup: this.listGroup,
      };
      console.log("create", data);
      GroupService.createGroupListElastic(this.elastic, platform, data)
        .then((response) => {
          // console.log('create grouplist',response);
          this.groupList();
          this.created_at_grouplist = time;
        })
        .catch((err) => {
          console.log("grouplist err ->", err);
        });
    },
    deleteGroup(username) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.leave-group-you") + username,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.leave-group"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.user = username;
          this.loadingleave = true;
          let data = {
            group: username,
          };

          // console.log(data);
          GroupService.leaveGroup(data)
            .then((response) => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Leave Group Success",
                showConfirmButton: false,
                timer: 1500,
              });
              this.loadingleave = false;
              this.user = "";
              this.groupListTelegram();
            })
            .catch((err) => {
              this.user = "";
              console.log(err);
              this.loadingleave = false;
            });
        }
      });
    },
    joinGroup(username) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.join-group-you") + username,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.join-group"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingsearch = true;
          let data = {
            group: username,
          };
          // console.log(data);
          GroupService.joinGroupTelegram(data)
            .then((response) => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Join Group Success",
                showConfirmButton: false,
                timer: 1500,
              });
              this.groupListTelegram();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onDelete(id) {
      console.log("delete data:", id);
    },
    onView(id) {
      console.log("details data:", id);
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },

    sortingArray() {
      const array = this.tableData;
      const sortedArray = array.sort((b, a) => {
        if (a.pin > b.pin) {
          return 1;
        }
        if (a.pin < b.pin) {
          return -1;
        }
        return 0;
      });
      this.tableData = [];
      this.pin_group = [];
      sortedArray.forEach((val, index) => {
        const data = {
          no: index + 1,
          id: val.id,
          title: val.title,
          username: val.username,
          // "account" : val.account,
          participants_count: val.participants_count,
          date: this.formatDate(val.date),
          about: val.about,
          message: val.message,
          pin: val.pin,
        };
        this.tableData.push(data);
        if (val.pin) {
          this.pin_group.push(data);
        }
      });

      // console.log('sort', sortedArray);
    },

    removeCaracter(value) {
      let grup = value.slice(1, -1);
      return grup.replace("/", "").replace("\ ", "").replace("'", "");
    },

    removeSpace(value) {
      let hsl = value.replace(/\s/g, "");
      return (this.searchKey = hsl);
    },

    removeSpaceUser(value) {
      // console.log('remove', value);
      let hsl = value.replace(/\s/g, "");
      return (this.searchKeyUsers = hsl);
    },

    SearchUsersTele() {
      // console.log(data);
      if (this.searchKeyUsers != "") {
        this.loading_search_users = true;
        this.SearchResultUsers = [];
        this.userList = "";
        (this.error_users = ""), (this.search_users = true);

        let sk = this.searchKeyUsers.substring(0, 2);
        if (sk == "62") {
          var data_search = {
            size: 1000,
            query: {
              match: {
                "listmember.phone.keyword": this.searchKeyUsers,
              },
            },
          };
        } else {
          var data_search = {
            size: 1000,
            query: {
              match: {
                "listmember.username.keyword": this.searchKeyUsers,
              },
            },
          };
        }

        GroupService.SearchGroupByPhone(this.elastic, data_search)
          .then((response) => {
            //  console.log(response.data.hits.total.value);
            let ttl = response.data.hits.total.value;

            if (ttl > 0) {
              this.SearchResultUsers = response.data.hits.hits;
              var username = response.data.hits.hits[0]._id;
              this.getUserTele(username);
            } else {
              this.loading_search_users = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading_search_users = false;
            // console.log('gagalx',  this.loading_search_users);
            //  if( err.response.status == 500 ){
            //     this.error_users = this.$t('all.error-500');
            //   } else if( err.response.status == 404 ){
            //     this.error_users = this.$t('all.error-404');
            //   }
          });
      }
    },

    getUserTele(username) {
      const data = {
        size: 1000,
        query: {
          match: {
            username: username,
          },
        },
      };
      // console.log('username', data);
      if (this.searchKeyUsers != "") {
        this.userList = [];
        GroupService.SearchListMemberByGroup(this.elastic, data)
          .then((response) => {
            var dataMember = response.data.hits.hits[0]._source.listmember;
            // console.log('berhasil', dataMember);
            dataMember.forEach((val) => {
              const data = {
                user_id: val.user_id,
                username: val.username,
                first_name: val.first_name,
                last_name: val.last_name,
                phone: val.phone,
              };
              if (
                data.phone == this.searchKeyUsers ||
                data.username == this.searchKeyUsers
              ) {
                this.userList.push(data);
              }
            });
            this.loading_search_users = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading_search_users = false;
            console.log("gagal");
          });
      }
    },

    pin(val) {
      var data_res = {
        id: val.id,
        date: val.date,
        title: val.title,
        username: val.username,
        participants_count: val.participants_count,
        about: val.about,
        message: val.message,
        pin: 1,
      };
      Swal.fire({
        title: "Pin",
        text: "Pin Group",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: "Pin",
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.pin_group.length < 5) {
            let index = this.tableData.findIndex(
              (element) => element["id"] == data_res.id
            );
            this.tableData.splice(index, 1);
            this.tableData.push(data_res);

            // console.log('data', data_res);
            // console.log('delete', index);
            // console.log('ntd', this.tableData);

            var platform = "telegram";
            var today = new Date();
            var time = today.toLocaleString("en-US", {
              timeZone: "Asia/Jakarta",
            });
            const data = {
              created_at: time,
              username: platform,
              listgroup: this.tableData,
            };
            // console.log('data save', data);
            GroupService.createGroupListElastic(this.elastic, platform, data)
              .then((response) => {
                this.sortingArray();
                this.created_at_grouplist = time;
              })
              .catch((err) => {
                console.log("grouplist err ->", err);
              });
          } else {
            // console.log('max',  this.pin_group.length);
            Swal.fire({
              icon: "error",
              title: "Failed",
              text: "Maximal Pin 5 !",
            });
          }
        }
      });
    },

    unpin(val) {
      const data_res_unpin = {
        id: val.id,
        date: val.date,
        title: val.title,
        username: val.username,
        participants_count: val.participants_count,
        about: val.about,
        message: val.message,
        pin: 0,
      };
      Swal.fire({
        title: "Unpin",
        text: "Unpin Group",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: "Unpin",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log('id unpin',  data_res_unpin);
          let index = this.tableData.findIndex(
            (element) => element["id"] == data_res_unpin.id
          );
          this.tableData.splice(index, 1);
          this.tableData.push(data_res_unpin);

          // console.log('data', data_res_unpin);
          // console.log('delete', index);
          // console.log('ntd', this.tableData);

          var platform = "telegram";
          var today = new Date();
          var time = today.toLocaleString("en-US", {
            timeZone: "Asia/Jakarta",
          });
          const data = {
            created_at: time,
            username: platform,
            listgroup: this.tableData,
          };
          // console.log('data save', data);
          GroupService.createGroupListElastic(this.elastic, platform, data)
            .then((response) => {
              this.sortingArray();
              this.created_at_grouplist = time;
            })
            .catch((err) => {
              console.log("grouplist err ->", err);
            });
        }
      });
    },

    formatDateRefresh(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  },

  mounted() {
    this.totalRows = this.items.length;
    this.getPreferences();
  },
};
</script>

<style scoped>
.badge {
  border-radius: 2%;
}
.btn {
  border-radius: 7%;
}
</style>
